import React from "react";
import { ReactSortable } from "react-sortablejs"; // Import ReactSortable
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import { MasterDataSelections } from "./EditFieldMasterData";
import MultiRadio from "../../../components/FormComponents/MultiRadio";
import Label from "../../../components/FormComponents/Label";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const InlineMasterdataSelection = ({ value, onChange, masterDataTypes = [], showKeyBox = true }) => {
  const addDataOption = () => {
    onChange({
      ...value,
      values: [...value.values, { label: "", value: "" }]
    });
  };
  const handleDataInput = (name, newValue, index) => {
    // const newObj = JSON.parse(JSON.stringify(editFieldData));
    const newObj = { ...value };
    newObj.values[index][name] = newValue;
    if (!showKeyBox) {
      newObj.values[index]["label"] = newValue;
    }
    onChange(newObj);
  };

  const deleteOptionData = (index) => {
    // const newObj = JSON.parse(JSON.stringify(editFieldData));
    const newObj = { ...value };
    newObj.values.splice(index, 1);
    onChange(newObj);
  };

  const handleDataChange = (newValue, type) => {
    // const newObj = JSON.parse(JSON.stringify(editFieldData));
    const newObj = { ...value };
    newObj[type] = newValue;
    onChange(newObj);
  };
  const handleSetList = (newValues) => {
    // const newObj = JSON.parse(JSON.stringify(editFieldData));
    const newObj = { ...value };
    newObj.values = newValues;
    onChange(newObj);
  };

  // const getMasterDataTypes = () => {
  //   switch (editFieldData.type) {
  //     case "select-chips":
  //     case "radio":
  //       return ["learning_text"];
  //     default:
  //       return [];
  //   }
  // };

  return (
    <>
      <div className="flex_column gap_2 ">
        <Label>Data</Label>
        <MultiRadio
          options={[
            {
              id: "default",
              name: "Master data"
            },
            {
              id: "inline",
              name: "Inline"
            }
          ]}
          selectedValue={value.method}
          onChange={(e) => handleDataChange(e.target.value, "method")}
        />
      </div>
      {value.method === "default" && (
        // <div className="builder_form">
        <MasterDataSelections
          selectedMasterData={value.data_key}
          onChange={(value) => handleDataChange(value, "data_key")}
          selectedTypes={masterDataTypes}
        />
        // </div>
      )}

      {value.method === "inline" && (
        <>
          {value.values.length > 0 && (
            <div className="form_data_action_wrapper">
              <Label className="form_appuser_filter_tag">Inline style</Label>
              <>
                <ReactSortable
                  list={value.values}
                  setList={handleSetList}
                  className="builder_form"
                  handle=".Recordsviewfielddragclass"
                  animation="200"
                  easing="ease-out"
                >
                  {value.values.map((data, index) => (
                    <div className={`flex_row align_center gap_1`} key={index}>
                      <MaterialIcon
                        name="drag_indicator"
                        className="Recordsviewfielddragclass"
                        style={{ fontSize: "16px", cursor: "all-scroll" }}
                      />
                      {showKeyBox && (
                        <Input
                          name="label"
                          placeholder="Enter Label"
                          value={data.label}
                          onChange={(e) => handleDataInput(e.target.name, e.target.value, index)}
                        />
                      )}

                      <Input
                        name="value"
                        placeholder="Enter Value"
                        value={data.value}
                        onChange={(e) => handleDataInput(e.target.name, e.target.value, index)}
                      />

                      <MaterialIcon
                        name="delete"
                        className="builder_action_btn delete"
                        onClick={() => deleteOptionData(index)}
                      />
                    </div>
                  ))}
                </ReactSortable>
                <div className="d_flex justify_end mt_2">
                  <Button size="small" variant="secondary" onClick={addDataOption}>
                    +
                  </Button>
                </div>
              </>
            </div>
          )}
          {value.values.length === 0 && (
            <div className="w_100 d_flex align_center justify_between">
              <Label>Add label and value </Label>
              <Button variant="secondary" onClick={addDataOption}>
                + Add
              </Button>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default InlineMasterdataSelection;
